import type { GatewayBrowserClient } from "../gateway.ts";

export type QueueLaneInfo = {
  depth: number;
  active: number;
  maxConcurrent: number;
};

export type QueueStatusResult = {
  lanes: Record<string, QueueLaneInfo>;
  totalDepth: number;
  totalActive: number;
};

export type QueueStatusState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  queueStatusLoading: boolean;
  queueStatusError: string | null;
  queueStatus: QueueStatusResult | null;
};

export async function loadQueueStatus(state: QueueStatusState) {
  if (!state.client || !state.connected) {
    return;
  }
  if (state.queueStatusLoading) {
    return;
  }
  state.queueStatusLoading = true;
  state.queueStatusError = null;
  try {
    const res = (await state.client.request("queue.status", {})) as QueueStatusResult;
    state.queueStatus = res;
  } catch (err) {
    state.queueStatusError = String(err);
  } finally {
    state.queueStatusLoading = false;
  }
}
